export default __webpack_public_path__ + "static/media/cookers.58c3fe5f.png";